/* eslint-disable react/display-name */
import React, { Suspense } from 'react';
import { connect } from 'react-redux';
// javascript plugin used to create scrollbars on windows
import { Route, Switch } from 'react-router-dom';
// Helmet for SEO
import { Helmet } from 'react-helmet';

import adminRoutesList from 'routes/AdminRoutes.jsx';
import { isConfigAdmin, isFeatureEnabled } from 'config/featureAccess';
import { fetchFeatureFlagsService } from 'actions/admin/featureFlags';
import { CommonLoader } from 'views/admin/Common/Loader';
import GuestRoute from 'routesAuth/GuestRoute.jsx';
import UserRoute from 'routesAuth/UserRoute.jsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import colors from '../config/colors';

// import { PrismicQuery } from "../config/prismicClient";
import { MainLayout } from '../theme/MainLayout';

// eslint-disable-next-line no-unused-vars
import ErrorBoundary from './ErrorBoundary';
import AppBackdrop from './Backdrop';
import Loadable from 'react-loadable';
import UserAdmissionForm from 'views/admin/Admissions/components/UserAdmissionForm';
import AppProvider from 'providers/AppProvider';
import AuthLoading from 'layouts/AuthLoading';

const Header = Loadable({
  loader: () => import('components/Header/Header.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const Footer = Loadable({
  loader: () => import('components/Footer/Footer.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const Sidebar = Loadable({
  loader: () => import('components/Sidebar/Sidebar.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const NoMatchPage = Loadable({
  loader: () => import('views/admin/Common/NoMatchPage.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const ViewReportModal = Loadable({
  loader: () => import('views/admin/Common/ViewReportModal.jsx'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const NotificationAlertList = Loadable({
  loader: () => import('views/admin/Common/NotificationAlertList'),
  loading: () => <AppBackdrop isOpen={true} />,
});
const LandingPage = Loadable({
  loader: () => import('views/Landing/LandingPage'),
  loading: () => <AppBackdrop isOpen={true} />,
});

class AdminApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: colors.themeColor,
      activeColor: '#fff',
    };
  }

  // async componentDidMount() {
  // if(this.props.location.pathname) {
  //   await updateStyle(this.props.location.pathname)
  // }
  // const pData = await PrismicQuery();
  // }

  // async componentDidUpdate(prevProps) {
  //   if(prevProps.location.pathname !== this.props.location.pathname) {
  //     await updateStyle(this.props.location.pathname)
  //   }
  // }

  componentDidMount() {
    this.loadFeatureFlags();
  }

  componentDidUpdate() {
    this.loadFeatureFlags();
  }

  // The user's feature switches (see actions/admin/featureFlags.js), read once per login.
  loadFeatureFlags = () => {
    const { isAuthenticated, featureFlagsLoaded, loggedUserSchool, loggedUserEmail, loggedUserToken } = this.props;
    if (!isAuthenticated || featureFlagsLoaded || this.loadingFeatureFlags || !loggedUserEmail) return;
    this.loadingFeatureFlags = true;
    this.props
      .fetchFeatureFlags({ schoolId: loggedUserSchool, email: loggedUserEmail, token: loggedUserToken })
      .finally(() => {
        this.loadingFeatureFlags = false;
      });
  };

  navigateToHome = () => {
    this.props.history.push('/admin/dashboard');
  };

  navToCloneBatch = () => {
    this.props.history.push('/admin/clone-batch');
  };

  render() {
    const { location, isAuthenticated, reportUrl, isOpenReportModal, headingName } = this.props;
    return (
      <>
        {/* <ErrorBoundary> */}
        <Suspense fallback={isAuthenticated ? <AppBackdrop isOpen={true} /> : <AuthLoading />}>
          <AppProvider>
            <div className={isAuthenticated ? 'wrapper' : null}>
              <Helmet
                title="Scholae"
                meta={[
                  {
                    name: 'description',
                    content:
                      'An Advanced Communication Application for Authorities, Parents & Students With the experience of education sector, scholae.in, scholae, school, school management, school ERP system, school app, education, school education, college, college app, academic, academic app, Chennai, Coimbatore, namakkal, Dharmapuri, Tamilnadu, Tamil nadu, Kerala, Karnataka, Trichy, Kochin, Trinvandram, Bangalore, Mumbai, Pune, India',
                  },
                  { property: 'og:type', content: 'application.education' },
                  {
                    property: 'og:title',
                    content:
                      'Scholae - School & Academic App, Scholae, scholae.in, School management, School app, School ERP',
                  },
                  { property: 'og:image', content: require('assets/img/playstore.png').default },
                  { property: 'og:url', content: 'https://scholae.in' },
                ]}
              />

              {isAuthenticated && location.pathname !== '/' && !location.pathname?.includes('/user/admission-form') && (
                <Sidebar
                  {...this.props}
                  routes={adminRoutesList}
                  bgColor={this.state.backgroundColor}
                  activeColor={this.state.activeColor}
                />
              )}
              <PerfectScrollbar>
                <div
                  className={
                    !location.pathname.includes('login') &&
                    location.pathname !== '/' &&
                    !location.pathname?.includes('/user/admission-form')
                      ? 'main-panel'
                      : null
                  }>
                  {isAuthenticated &&
                    location.pathname !== '/' &&
                    !location.pathname?.includes('/user/admission-form') && (
                      <Header
                        {...this.props}
                        schools={this.props.schoolData.content}
                        navigateToHome={this.navigateToHome}
                        navToCloneBatch={this.navToCloneBatch}
                      />
                    )}
                  <Switch>
                    <Route location={location} exact path="/" component={LandingPage} />
                    <Route
                      location={location}
                      exact
                      path="/user/admission-form/:schoolId/:phoneNumber/:admissionId"
                      component={UserAdmissionForm}
                    />
                    {adminRoutesList.map((prop, key) => {
                      // A route tied to a feature exists only for the roles it allows and users who have the feature
                      // switched on, so its URL shows "not found" for everyone else. Until the user's switches
                      // are read it shows a loader rather than flashing "not found".
                      if (
                        prop.configAdminOnly &&
                        this.props.isAuthenticated &&
                        (!prop.accessRoles.includes(this.props.loggedUserRole) ||
                          !isConfigAdmin(this.props.loggedUserEmail))
                      ) {
                        return null;
                      }
                      if (prop.feature && this.props.isAuthenticated) {
                        if (!this.props.featureFlagsLoaded) {
                          return (
                            <Route key={key} location={location} exact path={prop.path} component={CommonLoader} />
                          );
                        }
                        if (
                          !prop.accessRoles.includes(this.props.loggedUserRole) ||
                          !isFeatureEnabled(prop.feature, this.props.featureFlags)
                        ) {
                          return null;
                        }
                      }
                      if (prop?.isGuest) {
                        return (
                          <Route key={key} location={location} exact path={prop.path} component={prop.component} />
                        );
                      }
                      if (prop.path.includes('/login') || prop.path.includes('/user/admission-form')) {
                        const component = (
                          <GuestRoute
                            key={key}
                            location={location}
                            exact
                            // ={prop.exact !== undefined ? prop.exact : true}
                            path={prop.path}
                            component={prop.component}
                          />
                        );
                        return MainLayout(component, key);
                      }
                      return (
                        <UserRoute location={location} exact path={prop.path} component={prop.component} key={key} />
                      );
                    })}
                    <Route component={NoMatchPage} />
                  </Switch>
                  {location.pathname !== '/' &&
                  !location.pathname?.includes('/user/admission-form') &&
                  isAuthenticated ? (
                    <Footer fluid />
                  ) : null}
                </div>
              </PerfectScrollbar>
            </div>
            <AppBackdrop />
            <NotificationAlertList />
            <ViewReportModal reportUrl={reportUrl} isOpenReportModal={isOpenReportModal} headingName={headingName} />
          </AppProvider>
        </Suspense>
        {/* </ErrorBoundary> */}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: !!state.auth.loggedUserToken,
    loggedUserToken: state.auth.loggedUserToken,
    loggedUserEmail: state.auth.loggedUserEmail,
    loggedUserSchool: state.auth.loggedUserSchool,
    loggedUserRole: state.auth.loggedUserRole,
    featureFlags: state.auth.featureFlags,
    featureFlagsLoaded: state.auth.featureFlagsLoaded,
    schoolData: state.schools.schoolData,
    school: state.schools.school,
    reportUrl: state.schools.reportUrl,
    isOpenReportModal: state.schools.isOpenReportModal,
    headingName: state.schools.headingName,
  };
};

const mapDispatchToProps = dispatch => ({
  fetchFeatureFlags: data => dispatch(fetchFeatureFlagsService(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminApp);
